import classnames from 'classnames';
import { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { handleKeyboardSelect } from '../../helpers/Accessibility';
import style from './LoadMoreSlots.module.scss';

interface LoadMoreSlotsProps {
  loading: boolean;
  loadMoreSlots?: () => void;
}

export const LoadMoreSlots: FC<LoadMoreSlotsProps> = ({ loadMoreSlots, loading }) => {
  const { t } = useTranslation();

  const loaderClassNames = classnames(style.slotsLoader, 'partner-font-color');

  const classes = classnames({
    [style.loadMoreSlots]: true,
    'partner-border-font-color': true,
  });

  const handleClick = useCallback(() => {
    if (!loading && loadMoreSlots) loadMoreSlots();
  }, [loading, loadMoreSlots]);

  const handleKeyDown = useMemo(() => handleKeyboardSelect(handleClick), [handleClick]);

  return (
    <div className={classes} onClick={handleClick} onKeyDown={handleKeyDown} role="button" tabIndex={0}>
      <span>{t('slots:loadMoreSlots')}</span>
      {!!loading && <div className={loaderClassNames}/>}
    </div>
  );
};
